import {observer} from 'mobx-react';
import {TimeOffRequestDetailsState} from '../state';
import {withState, t} from 'shared/core';
import {Display, Layout, Panel, CustomHours, List, ActionLink, Accordion} from 'components';
import Usage from './Usage';
import RequestHistory from './RequestHistory';

const TimeOffRequestDetails = observer(({uiState}) => {
  const {request, daysOff, summaryItems, employee} = uiState;
  const type = request.timeOffType.name;

  return (
    <div>
      <Display
        title={t('employees.profile.time_off.request.View Time Off Request')}
        backPath={`/${employee.id}/time-off`}
        backTitle={employee.name}
      />
      <Layout>
        <Layout.Section>
          <Panel.Stack loose>
            <Panel>
              <Panel.Header
                title={t('time_off.requests.TYPE_REQUEST', {type})}
              />
              <Panel.Subheader title={request.datesView} />
              <List items={summaryItems} />
              <Panel.Separator className='mt3' />
              <Panel.Subheader title={t('time_off.requests.Days Off')} />
              <CustomHours models={daysOff.slice(0, TimeOffRequestDetailsState.MAX_DAYS_OFF_ITEMS)} />
              <div className='mb2'>
                <Accordion active={uiState.expanded}>
                  <div className='mt1'>
                    <CustomHours models={daysOff.slice(TimeOffRequestDetailsState.MAX_DAYS_OFF_ITEMS)} />
                  </div>
                </Accordion>
              </div>
              {daysOff.length > TimeOffRequestDetailsState.MAX_DAYS_OFF_ITEMS && <ActionLink
                onClick={() => uiState.expanded = !uiState.expanded}
                className='h6 waterloo'>
                {uiState.expandedText}
              </ActionLink>}
            </Panel>
            <RequestHistory uiState={uiState} />
          </Panel.Stack>
        </Layout.Section>
        <Layout.Section secondary>
          <Usage uiState={uiState} />
        </Layout.Section>
      </Layout>
    </div>
  )
});

export default withState(TimeOffRequestDetails, TimeOffRequestDetailsState);
